import { render, staticRenderFns } from "./case_detail.vue?vue&type=template&id=6bd01a29&scoped=true"
import script from "./case_detail.vue?vue&type=script&lang=js"
export * from "./case_detail.vue?vue&type=script&lang=js"
import style0 from "./case_detail.vue?vue&type=style&index=0&id=6bd01a29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd01a29",
  null
  
)

export default component.exports